import { refinementList } from "instantsearch.js/es/widgets";
import { renderToString } from "react-dom/server";
import { Checkbox } from "../components/Checkbox";

export type Filter = {
  facetReference: string;
  label: string;
};

export const getPinnedFacets = (items, facetReference, results) => {
  const facets =
    results?.renderingContent?.facetOrdering?.values?.[facetReference]?.order ||
    [];
  return items.filter((item) => facets.includes(item.value));
};

export const generateFacetRefinement = (filters: Filter[]) => {
  if (!filters || filters.length === 0) return [];

  return filters.map((filter: Filter) => {
    const { facetReference } = filter;
    return refinementList({
      container: `#${facetReference}`,
      attribute: facetReference,
      limit: 200,
      templates: {
        item: ({ label = "", count = 0, isRefined = false, value = "" }) => {
          return renderToString(
            <Checkbox
              name={`${facetReference}-${value.toLowerCase()}`}
              label={label}
              count={count}
              isRefined={isRefined}
            />
          );
        },
      },
      transformItems(items, { results }) {
        return getPinnedFacets(items, facetReference, results);
      },
    });
  });
};
